// ---------------------------------------------------------------------------
// Core
// ---------------------------------------------------------------------------

import 'bootstrap';
import { initApplicationInstance } from './init/core/Application';

// ---------------------------------------------------------------------------
// Wordpress
// ---------------------------------------------------------------------------

import initHeader from './init/startup/header';
// import initScrollIndicator from './init/startup/scroll_position';

// ---------------------------------------------------------------------------
// Libraries
// ---------------------------------------------------------------------------

import registerGSAPPlugins from './init/libs/register_gsap_plugin';
// import initLenis from './init/libs/lenis';
// import { initThree } from './init/libs/three_instance';
// import { initBarba } from './init/libs/initBarba';

// ---------------------------------------------------------------------------
// Animations
// ---------------------------------------------------------------------------

// import enableAnimFrom from './init/animations/animFrom';

// ---------------------------------------------------------------------------
// Page scripts
// ---------------------------------------------------------------------------

import homePageScript from './page-scripts/homePage';
import officesPageScript from './page-scripts/officesPage';

// ---------------------------------------------------------------------------
// Init
// ---------------------------------------------------------------------------

function getCurrentPageScript() {
    const path = window.location.pathname;

    if (path === '/') {
        return homePageScript;
    }

    if (document.querySelector('#offices_page')) {
        return officesPageScript;
    }

    return null;
}

function prefillOfficeInterest() {
    const interest = document.querySelector<HTMLElement>('[data-office-interest]');
    const officeNumber = interest?.dataset.officeInterest;

    if (!officeNumber) return;

    const message = `I'm interested in Office ${officeNumber}`;
    const applyPrefill = () => {
        const textarea = document.querySelector<HTMLTextAreaElement>('#contact_page textarea');

        if (textarea && !textarea.value.trim()) {
            textarea.value = message;
            textarea.dispatchEvent(new Event('input', { bubbles: true }));
        }
    };

    applyPrefill();
    window.setTimeout(applyPrefill, 500);
}

function initBackToTop() {
    document.querySelectorAll<HTMLAnchorElement>('.back-to-top').forEach((link) => {
        link.addEventListener('click', (event) => {
            event.preventDefault();
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth',
            });
        });
    });
}

document.addEventListener('DOMContentLoaded', function () {
    document.fonts.ready.then(() => {
        initApplicationInstance();

        initHeader();
        // initScrollIndicator();

        registerGSAPPlugins();
        // initLenis();
        // initThree();
        // initBarba(getCurrentPageScript);

        // // animations
        // enableAnimFrom();

        // // page
        getCurrentPageScript()?.();
        prefillOfficeInterest();
        initBackToTop();
    });
});
